module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid15_800x633.8fbf0de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid15_800x633.jpg
// module id = ug+d
// module chunks = 0